var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#BDCBD9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23317 11.75L11.0498 7.93334L10.3998 7.28334L7.23317 10.45L5.5165 8.73334L4.8665 9.38334L7.23317 11.75ZM3.6665 14.6667C3.39984 14.6667 3.1665 14.5667 2.9665 14.3667C2.7665 14.1667 2.6665 13.9333 2.6665 13.6667V2.33334C2.6665 2.06668 2.7665 1.83334 2.9665 1.63334C3.1665 1.43334 3.39984 1.33334 3.6665 1.33334H9.68317L13.3332 4.98334V13.6667C13.3332 13.9333 13.2332 14.1667 13.0332 14.3667C12.8332 14.5667 12.5998 14.6667 12.3332 14.6667H3.6665ZM9.18317 5.43334V2.33334H3.6665V13.6667H12.3332V5.43334H9.18317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTask);
export default __webpack_public_path__ + "static/media/icon-task.1091b36f6bda181aac6217d4f178cb65.svg";
export { ForwardRef as ReactComponent };